import { render, staticRenderFns } from "./FishButtonCanvasComponent.vue?vue&type=template&id=48e1338b&"
import script from "./FishButtonCanvasComponent.vue?vue&type=script&lang=ts&"
export * from "./FishButtonCanvasComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports